import { combineReducers, createReducer } from '@reduxjs/toolkit';
import { displayQueue } from './displayQueue';
import { silentModeSlice } from './silentMode';
import * as historySlice from './historySlice';
import { interactiveCreate, objectConfig } from '../../actions/actions';

const emojiReducers = combineReducers({
  enabled: createReducer(false, {
    [objectConfig.fulfilled](_, action) {
      return action.payload.emoji?.enabled ?? false;
    },
  }),
  silentMode: silentModeSlice.reducer,
  displayQueue: displayQueue.reducer,
  history: historySlice.reducer,
  updateInterval: createReducer(60, {
    [interactiveCreate](state, action) {
      const { payload } = action;
      return payload.mns_config.emoji_interval;
    },
  }),
});

const actions = {
  silentMode: {
    set: silentModeSlice.actions.setSilent,
    on: silentModeSlice.actions.on,
    off: silentModeSlice.actions.off,
    toggle: silentModeSlice.actions.toggle,
  },
  send: displayQueue.actions.send,
  clearQueue: displayQueue.actions.clearQueue,
  pushToQueue: displayQueue.actions.pushToQueue,

  appendChunk: historySlice.actions.appendChunk,
};

/**
 * @type {{actions, emojiReducer: EmojiState}}}
 */
const exports = {
  actions,
  emojiReducers,
};

export default exports;

/**
 * @typedef {Object} EmojiIcon
 * @property {string} name
 * @property {string} url
 */

/**
 * @typedef {Object} DisplayEmoji
 * @property {string} name
 * @property {number} count
 * @property {boolean} isOwn
 */

/**
 * @typedef {Object} EmojiState
 * @property {boolean} enabled
 * @property {EmojiIcon[]} icons
 * @property {string} mode
 * @property {DisplayEmoji[]} displayQueue
 */

/**
 *
 * @typedef {Object} EmojiHistoryChunk
 * @property {number} from
 * @property {number} to
 * @property {string} id
 * @property {string} [date]
 * @property {string} [fetchStatus]
 * @property {string} [requestId]
 * @property {number} timestamp
 * @property {DisplayQueueItem[]} [results=[]] - at last very similar
 */
